// 谷歌数据埋点 （增强型电子商务）

import API from '@/api'

/**
  衡量购买情况
  gtag('event', 'purchase', {
    "transaction_id": "24.031608523954162", // ********必填
    "affiliation": "Google online store",
    "value": 23.07, // ********必填
    "currency": "USD", // ********必填
    "tax": 1.24,
    "shipping": 0,
    "items": [ // ********必填
      {
        "id": "P12345", // ********必填
        "name": "Android Warhol T-Shirt", // ********必填
        "list_name": "Search Results",
        "brand": "Google",
        "category": "Apparel/T-Shirts",
        "variant": "Black",
        "list_position": 1,
        "quantity": 2, // ********必填
        "price": '2.0' // ********必填
      },
      {
        "id": "P67890",
        "name": "Flame challenge TShirt",
        "list_name": "Search Results",
        "brand": "MyBrand",
        "category": "Apparel/T-Shirts",
        "variant": "Red",
        "list_position": 2,
        "quantity": 1,
        "price": '3.0'
      }
    ]
  });
*/

/**
 * 订单 交易单id
 * @param {String} paymentId
 */

export function gtagReport(paymentId) {
  API.getPaymentTransaction(paymentId).then(({ code, data }) => {
    if (code !== 10000) return
    window.gtag && window.gtag('event', 'purchase', {
      transaction_id: data.paymentId,
      value: data.amount,
      currency: data.currencyCode,
      items: data.itemVos.map(item => ({
        id: item.id,
        name: item.productName,
        quantity: item.productNum,
        price: item.purchasePrices
      }))
    })
    // window.gtag && window.gtag('event', 'purchase', {
    //   'send_to': 'G-4335ZYH2TJ',
    //   transaction_id: data.paymentId,
    //   value: data.amount,
    //   currency: data.currencyCode,
    //   items: data.itemVos.map(item => ({
    //     id: item.id,
    //     name: item.productName,
    //     quantity: item.productNum,
    //     price: item.purchasePrices
    //   }))
    // })
  })
}
